
import { createStore } from 'vuex';
import ManageUser from '@/store/common/ManageUser';
import Home from '@/store/modules/Home';
import Notifications from '@/store/common/Notifications';
// API
import APISecurity from '@/store/modules/API/Security';
import APIOrganization from '@/store/modules/API/Organization';
import APIJobSearch from '@/store/modules/API/JobSearch';
import APIOrganizacionUser from '@/store/modules/API/OrganizationUser';
import APIStuff from '@/store/modules/API/Stuff';
import APIExternal from '@/store/modules/API/External';
import APIExternalForgeAuth from '@/store/modules/API/ExternalForgeAuth';

export default createStore({
  modules: {
    ManageUser,
    Notifications,
    Home,
    APISecurity,
    APIOrganization,
    APIJobSearch,
    APIOrganizacionUser,
    APIStuff,
    APIExternal,
    APIExternalForgeAuth
  }
});